import { useEffect } from "react";
import { ObraInformacoes } from "../../../../domain/models/obra_informacoes";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { ObraInformacoesForm, ObraInformacoesSchema } from "../../../schemas/Obras_informacoesgerais/obra_informacoes";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import { FuncionarioDropDown } from "../../../../../../common/domain/models/funcionario_dropdown";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";

import dayjs from "dayjs";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";

/**
 * ObraInformacoesModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  funcionariosInfObraDropdown: FuncionarioDropDown[],
  selectedObraInformacoes: ObraInformacoes | null,
  onClose: () => void;
  onSubmit: (e: ObraInformacoesForm) => void;
};

export const ObraInformacoesModal = ({
  open,
  saving,
  loading,
  funcionariosInfObraDropdown,
  selectedObraInformacoes,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<ObraInformacoesForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(ObraInformacoesSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedObraInformacoes) {
        hookForm.setValue('idFuncionario', selectedObraInformacoes.idFuncionario);
        hookForm.setValue('descInformacoes', selectedObraInformacoes.descInformacoes ?? '');

        if (selectedObraInformacoes.data) {
          hookForm.setValue('data', dayjs(selectedObraInformacoes.data).toDate());
        }
      } else {
        hookForm.reset();
      }
    }
  }, [
    open,
    selectedObraInformacoes,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title={'Informação Obra'}
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title={"Informações"} arrangement="fullRow">
        <>
          <DefaultFormAutocomplete
            name='idFuncionario'
            label='Responsável'
            getOptionDisabled={x => !x.canBeSelected}
            options={funcionariosInfObraDropdown}
            getOptionKey={x => x.idFuncionario}
            getOptionLabel={x => x.nome}
            reactHookForm={hookForm} />

          <FormDatePickerInput
            name='data'
            label='Data'
            required={true}
            reactHookForm={hookForm} />

          <DefaultFormInput
            name='descInformacoes'
            label='Informações'
            required={true}
            multiline={true}
            minRows={8}
            reactHookForm={hookForm} />

        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
}